import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';

@Component({
  selector: 'app-bottom-footer-buttons',
  templateUrl: './bottom-footer-buttons.component.html',
  styleUrls: ['./bottom-footer-buttons.component.scss'],
})
export class BottomFooterButtonsComponent implements OnInit, OnDestroy {

  mostra = true;
  /*
  La barra si nasconde automaticamente quando viene mostrata
  a video la tastiera perche' altrimenti copre (in certi casi lo fa ancora)
  i campi di input sotto di essa al netto dello scorrimento automatico
  dell schermo che a volte non succede
  https://github.com/ionic-team/ionic-native/issues/2306
  
  */
  private keyboardChangeSubscription: Subscription;

  constructor(
    private cdr: ChangeDetectorRef,
    ) { }

  ngOnInit() {
    this.keyboardChangeSubscription = fromEvent(window, 'keyboardWillShow').subscribe(_ => {
      this.mostra = false;
      this.cdr.detectChanges();

    });

    this.keyboardChangeSubscription.add(fromEvent(window, 'keyboardDidShow').subscribe(_ => {
      this.mostra = false;
      this.cdr.detectChanges();
    }));

    this.keyboardChangeSubscription.add(fromEvent(window, 'keyboardWillHide').subscribe(_ => {
      this.mostra = true;
      this.cdr.detectChanges();
    }));

    this.keyboardChangeSubscription.add(fromEvent(window, 'keyboardDidHide').subscribe(_ => {
      this.mostra = true;
      this.cdr.detectChanges();
    }));
  }

  ngOnDestroy() {
    this.keyboardChangeSubscription.unsubscribe();
  }

}
